import React from "react";

export default function FilterFieldLabel(props) {
    const { label, badge, color, background } = props;
    return (<div className='hovered' style={{display:"flex", justifyContent:"space-between", alignItems:"center"}}>
    <div>{label}</div>
    {badge && <div className='bg bg-grey onhover' style={{
            padding: "1px",
            minWidth: "26px",
            minHeight: "0px",
            height: "16px",
            lineHeight: "12px",
            fontSize: "10px",
            marginBottom: "0px",
            color: color || "#919191",
            backgroundColor: background || "rgba(216, 216, 216, 0.2)",
    }}>{badge}</div>}
</div>)
}